import { StyleSheet } from '@react-pdf/renderer';

export const styles = StyleSheet.create({
  page: {
    paddingTop: 32,
    paddingBottom: 32,
    paddingHorizontal: 40,
    fontSize: 10,
    fontFamily: 'Helvetica',
    color: '#111',
  },
  header: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 10,
  },
  logo: {
    width: 40,
    height: 40,
    marginRight: 14,
  },
  headerText: {
    flexGrow: 1,
    textAlign: 'center',
  },
  title: {
    fontSize: 13,
    fontWeight: 'bold',
  },
  subtitle: {
    fontSize: 12,
    fontWeight: 'bold',
    marginTop: 2,
  },
  meta: {
    fontSize: 9,
    marginTop: 3,
    color: '#444',
  },
  table: {
    marginTop: 10,
    borderWidth: 1,
    borderColor: '#000',
    borderStyle: 'solid',
  },
  tableHeader: {
    flexDirection: 'row',
    backgroundColor: '#e0e0e0',
    fontWeight: 'bold',
  },
  tableRow: {
    flexDirection: 'row',
  },
  tableRowEven: {
    flexDirection: 'row',
    backgroundColor: '#f3f3f3',
  },
  cell: {
    borderRightWidth: 1,
    borderColor: '#000',
    paddingVertical: 3,
    paddingHorizontal: 4,
    fontSize: 9,
  },
  cellNoRightBorder: {
    borderRightWidth: 0,
  },
  colEstagiario: { width: '26%' },
  colUnidade: { width: '26%' },
  colResponsavel: { width: '26%' },
  colStatus: { width: '12%' },
  colEditadoEm: { width: '10%' },
  statusIcon: {
    fontSize: 12,
    textAlign: 'center',
    paddingVertical: 1,
  },
  legend: {
    marginTop: 10,
    fontSize: 9,
    color: '#444',
  },
  legendTitle: {
    fontSize: 9,
    fontWeight: 'bold',
    marginBottom: 2,
  },
  legendRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  legendItem: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 4,
  },
  footer: {
    marginTop: 14,
    paddingTop: 8,
    borderTopWidth: 1,
    borderTopColor: '#d0d0d0',
    fontSize: 9,
    color: '#444',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
});

